import { useEffect, useRef, useState } from "react";
import image_bg_video from "../../img/logo_green.svg";

declare global {
  interface Window {
    videojs: any;
  }
}

const VideoComponent = ({ post }: any) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const playerRef = useRef<any>(null);
  const [error, setError] = useState<string | null>(null);

  const videoSrc = post?.file && typeof post?.file === "object"
    ? URL.createObjectURL(post?.file)
    : process.env.REACT_APP_STORAGE_URL + post?.file;

  const posterSrc = post?.cover 
    ? process.env.REACT_APP_STORAGE_URL + post?.cover 
    : image_bg_video;

  useEffect(() => {
    const initPlayer = () => {
      if (!videoRef.current) return;

      if (window.videojs) {
        try {
          if (playerRef.current) {
            playerRef.current.dispose();
          }

          playerRef.current = window.videojs(videoRef.current, {
            autoplay: false,
            controls: true,
            fill: true,
            preload: 'auto',
            poster: posterSrc,
            sources: [{
              src: videoSrc,
              type: post?.file?.type || (videoSrc.toLowerCase().endsWith('.webm') ? 'video/webm' : 'video/mp4')
            }]
          });

          playerRef.current.on('error', () => {
             const err = playerRef.current.error();
             console.error('Video.js error:', err);
             setError(`Video error: ${err.message}`);
          });

          playerRef.current.addClass('vjs-custom-skin');
        } catch (e) {
          console.error("Failed to initialize Video.js:", e);
          setError("Failed to initialize player");
        }
      } else {
        setError("Video library not loaded");
      }
    };

    // Delay initialization slightly to ensure DOM is ready
    const timeout = setTimeout(() => {
        if (window.videojs) {
            initPlayer();
        } else {
            let attempts = 0;
            const interval = setInterval(() => {
              attempts++;
              if (window.videojs) {
                initPlayer();
                setError(null);
                clearInterval(interval);
              } else if (attempts > 50) {
                clearInterval(interval);
                setError("Could not load video player library");
              }
            }, 200);
            return () => clearInterval(interval);
        }
    }, 100);

    return () => {
      clearTimeout(timeout);
      if (playerRef.current) {
        playerRef.current.dispose();
        playerRef.current = null;
      }
    };
  }, [post, videoSrc, posterSrc]);

  if (error) {
      return (
          <div style={{ width: "100%", aspectRatio: "16/9", background: "#333", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", borderRadius: "8px" }}>
              <div style={{ textAlign: "center" }}>
                  <p>{error}</p>
                  <video controls src={videoSrc} poster={posterSrc} style={{ maxWidth: "100%", maxHeight: "100%" }} />
              </div>
          </div>
      );
  }

  return (
    <div className="video-component-outer-wrapper" 
         style={{ 
           width: "100%", 
           background: "#000", 
           borderRadius: "8px", 
           overflow: "hidden",
           aspectRatio: "16/9",
           position: "relative"
         }}>
      <div data-vjs-player style={{ width: "100%", height: "100%" }}>
        <video
          ref={videoRef}
          className="video-js vjs-big-play-centered"
          playsInline
        />
      </div>
    </div>
  );
};

export default VideoComponent;
